var map = {
	"./icon-commodities-big.svg": "dccd",
	"./icon-commodities.svg": "3fc5",
	"./icon-crypto-big.svg": "cb60",
	"./icon-crypto.svg": "d2d8",
	"./icon-ew-big.svg": "b97d",
	"./icon-forex-big.svg": "6453",
	"./icon-forex.svg": "7238",
	"./icon-hamburger-blueberry.svg": "fab7",
	"./icon-hamburger.svg": "823a",
	"./icon-indian-big.svg": "9f5a",
	"./icon-indian.svg": "f4da",
	"./icon-indices-big.svg": "b6c9",
	"./icon-indices.svg": "bb30",
	"./icon-notification-off.svg": "7cf4",
	"./icon-notification-on.svg": "bc42",
	"./icon-stocks-big.svg": "427c",
	"./icon-stocks.svg": "cd36"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a23c";